import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import I18n from 'PMT/i18n/I18n';

import SecurityContext from 'utils/permissions/SecurityContext';

// -- entities
import Restaurant from 'PMT/entities/Restaurant';
import RestaurantColors from 'PMT/entities/RestaurantColors';
import RestaurantMultipart from 'PMT/entities/RestaurantMultipart';

// -- views
import RestaurantFormComponent from './RestaurantFormComponent';
import ColorView from 'components/color/ColorView';

export default class ThemeFormView extends RestaurantFormComponent {

  static propTypes = {
    restaurant: PropTypes.instanceOf(Restaurant),

    /**
     * @param RestaurantMultipart
     */
    onUpdate: PropTypes.func.isRequired
  };

  state = this.getDefaultState(this.props.restaurant);

  // -- actions

  onSubmit = (event: Object) => {
    event.preventDefault();

    const restaurantMultipart: RestaurantMultipart = new RestaurantMultipart();
    restaurantMultipart.colors = this.state.restaurantColors;

    this.props.onUpdate(restaurantMultipart);
  };

  // -- events colors changed

  onBackgroundColorChange = (uintColor: number) => {
    const restaurantColors: RestaurantColors = this.state.restaurantColors;
    restaurantColors.backgroundColor = uintColor;
    this.updateRestaurantColors(restaurantColors);
  };

  onFontColorChange = (uintColor: number) => {
    const restaurantColors: RestaurantColors = this.state.restaurantColors;
    restaurantColors.fontColor = uintColor;
    this.updateRestaurantColors(restaurantColors);
  };

  onTitleBackgroundColorChange = (uintColor: number) => {
    const restaurantColors:RestaurantColors = this.state.restaurantColors;
    restaurantColors.titleBackgroundColor = uintColor;
    this.updateRestaurantColors(restaurantColors);
  };

  onTitleFontColorChange = (uintColor: number) => {
    const restaurantColors: RestaurantColors = this.state.restaurantColors;
    restaurantColors.titleFontColor = uintColor;
    this.updateRestaurantColors(restaurantColors);
  };

  onActionBackgroundColorChange = (uintColor: number) => {
    const restaurantColors: RestaurantColors = this.state.restaurantColors;
    restaurantColors.actionBackgroundColor = uintColor;
    this.updateRestaurantColors(restaurantColors);
  };

  onActionFontColorChange = (uintColor: number) => {
    const restaurantColors: RestaurantColors = this.state.restaurantColors;
    restaurantColors.actionFontColor = uintColor;
    this.updateRestaurantColors(restaurantColors);
  };


  // -- tools

  getDefaultState(restaurant: Restaurant) {
    return {
      restaurantColors: restaurant.colors.copy()
    };
  }

  haveModifications() {
    const restaurantColors: RestaurantColors = this.props.restaurant.colors;

    return !(restaurantColors.backgroundColor === this.state.restaurantColors.backgroundColor
      && restaurantColors.fontColor === this.state.restaurantColors.fontColor
      && restaurantColors.titleBackgroundColor === this.state.restaurantColors.titleBackgroundColor
      && restaurantColors.titleFontColor === this.state.restaurantColors.titleFontColor
      && restaurantColors.actionBackgroundColor === this.state.restaurantColors.actionBackgroundColor
      && restaurantColors.actionFontColor === this.state.restaurantColors.actionFontColor
    );
  }

  updateRestaurantColors(restaurantColors: RestaurantColors) {
    this.setState({
      restaurantColors
    });
  }

  // -- renderers

  renderBackgroundColor() {
    const restaurantColors: RestaurantColors = this.state.restaurantColors;

    return (
      <div className="row">

        <div className="form-group">

          <div className="required col-xs-5 control-label">
            <label>
              {I18n.tr('restaurant_edit.theme.background_color')}
            </label>
          </div>

          <div className="col-xs-1 fake-input-group">
            <div className="form-control">
              <ColorView
                onColorChange={this.onBackgroundColorChange}
                color={restaurantColors.backgroundColor}
                enablePicker={SecurityContext.restaurantSettings.editTheme()}
              />
            </div>
          </div>
        </div>

      </div>
    );
  }

  renderFontColor() {
    const restaurantColors:RestaurantColors = this.state.restaurantColors;

    return (
      <div className="row">

        <div className="form-group">

          <div className="required col-xs-5 control-label">
            <label>
              {I18n.tr('restaurant_edit.theme.text_color')}
            </label>
          </div>

          <div className="col-xs-1 fake-input-group">
            <div className="form-control">
              <ColorView
                onColorChange={this.onFontColorChange}
                color={restaurantColors.fontColor}
                enablePicker={SecurityContext.restaurantSettings.editTheme()}
              />
            </div>
          </div>
        </div>

      </div>
    );
  }

  renderTitleBackgroundColor() {
    const restaurantColors:RestaurantColors = this.state.restaurantColors;

    return (
      <div className="row">
        <div className="form-group">
          <div className="required col-xs-5 control-label">
            <label>
              {I18n.tr('restaurant_edit.theme.title_background_color')}
            </label>
          </div>

          <div className="col-xs-1 fake-input-group">
            <div className="form-control">
              <ColorView
                onColorChange={this.onTitleBackgroundColorChange}
                color={restaurantColors.titleBackgroundColor}
                enablePicker={SecurityContext.restaurantSettings.editTheme()}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTitleFontColor() {
    const restaurantColors:RestaurantColors = this.state.restaurantColors;

    return (
      <div className="row">
        <div className="form-group">
          <div className="required col-xs-5 control-label">
            <label>
              {I18n.tr('restaurant_edit.theme.title_font_color')}
            </label>
          </div>

          <div className="col-xs-1 fake-input-group">
            <div className="form-control">
              <ColorView
                onColorChange={this.onTitleFontColorChange}
                color={restaurantColors.titleFontColor}
                enablePicker={SecurityContext.restaurantSettings.editTheme()}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderActionBackgroundColor() {
    const restaurantColors: RestaurantColors = this.state.restaurantColors;

    return (
      <div className="row">
        <div className="form-group">
          <div className="required col-xs-5 control-label">
            <label>
              {I18n.tr('restaurant_edit.theme.action_background_color')}
            </label>
          </div>

          <div className="col-xs-1 fake-input-group">
            <div className="form-control">
              <ColorView
                onColorChange={this.onActionBackgroundColorChange}
                color={restaurantColors.actionBackgroundColor}
                enablePicker={SecurityContext.restaurantSettings.editTheme()}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderActionFontColor() {
    const restaurantColors: RestaurantColors = this.state.restaurantColors;

    return (
      <div className="row">
        <div className="form-group">
          <div className="required col-xs-5 control-label">
            <label>
              {I18n.tr('restaurant_edit.theme.action_text_color')}
            </label>
          </div>

          <div className="col-xs-1 fake-input-group">
            <div className="form-control">
              <ColorView
                onColorChange={this.onActionFontColorChange}
                color={restaurantColors.actionFontColor}
                enablePicker={SecurityContext.restaurantSettings.editTheme()}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="edit_restaurant_form_view__theme">

        <div className="row">
          <form
            className="form-horizontal"
            noValidate
            onSubmit={this.onSubmit}
          >
            <div className="col-xs-12 col-sm-12 col-md-5">
              {this.renderBackgroundColor()}
              {this.renderFontColor()}
              {this.renderTitleBackgroundColor()}
              {this.renderTitleFontColor()}
              {this.renderActionBackgroundColor()}
              {this.renderActionFontColor()}
            </div>


            <div className="col-xs-12">
              {this.renderButtons()}
            </div>

          </form>
        </div>
      </div>
    );
  }

}
